export const CURRENT_GAME_VERSION = "1.52";
